import { styled } from '@mui/material/styles';
import { Box } from 'shared/mui/Box';

export const ContainerStyled = styled(Box)({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
});
